export const USER_PROFILE = "profile";
export const APPOINTMENTS = "appointments";
export const RESERVATIONS = "reservations";
export const SETTINGS = "settings";
export const ABOUT = "about";
export const CONTACT = "contact";
export const INVOICES = "invoices";

const AccountScreen = {
  USER_PROFILE,
  APPOINTMENTS,
  RESERVATIONS,
  SETTINGS,
  ABOUT,
  CONTACT,
  INVOICES,
};
export default AccountScreen;
